import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { type ReactNode } from 'react';

interface SetupSectionProps {
  children: ReactNode;
  description?: string;
  isFirst?: boolean;
  title: string;
  // Optional element rendered inline after the title (a status badge, a count).
  titleAccessory?: ReactNode;
}

export function SetupSection({
  children,
  description,
  isFirst = false,
  title,
  titleAccessory,
}: SetupSectionProps) {
  return (
    <Box pt={isFirst ? 0 : 5} pb={5}>
      <Box mb={3}>
        <HStack gap={2} align="center">
          <Text fontSize="sm" fontWeight="semibold" color="gray.900">
            {title}
          </Text>
          {titleAccessory}
        </HStack>
        {description && (
          <Text fontSize="xs" color="gray.500" lineHeight="1.5" mt={1}>
            {description}
          </Text>
        )}
      </Box>
      <VStack align="stretch" gap={3}>
        {children}
      </VStack>
    </Box>
  );
}

export function SetupFieldLabel({ children }: { children: ReactNode }) {
  return (
    <Text fontSize="xs" fontWeight="semibold" color="gray.700" mb={2}>
      {children}
    </Text>
  );
}
